import React from 'react'
import ControllerNavbar from '../../WebAppComponents/ControllerNavbar'
import "../../Styles/DeviceTable.css"
import "../../Styles/UserCard.css"
import "../../Styles/ControllerDashboard.css"
import WebMap from '../WebMap'
import axios from "axios";
import Header from "../../WebAppComponents/Header";
import { getUserDetails } from "../../Utility/AsyncStorageData";
import { useNavigate } from 'react-router-dom';
import DataTable from './DataTable';



function ControllerUser() {

    let navigate = useNavigate();
    var userDetails = getUserDetails();

    const [test, setTest] = React.useState(1);
    const [userData, setUserData] = React.useState({});
    const [error, setError] = React.useState('');

    const userColumns = [
        { label: "ID", key: "user_id", headerStyle: { borderRadius: "10px 0 0 10px" } },
        { label: "User", key: "name" },
        {
            label: "Email or Contact",
            key: "contact_or_email",
            render: (item) => item.contact !== "NA" ? item.contact : item.email
        },
        { label: "Company Name", key: "company_name" },
        {
            label: "Role",
            key: "role",
            render: (item) => ValidateRole(item.role_id)
        },
        {
            label: "Status",
            key: "status",
            cellStyle: { borderRadius: "0 10px 10px 0" },
            headerStyle: { borderRadius: "0 10px 10px 0" },
            render: (item) => (
                <h5 style={{
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    margin: "0px",
                    backgroundColor: item.is_active === "Y" ? "green" : "red"
                }}></h5>
            )
        }
    ];


    const navbarRender = (data) => {
        // console.log('Data received from child:', data);
        setTest(!test)
    };

    const errortimer = () => {
        setError(undefined)
    }

    const handleUserData = async () => {
        try {

            let url = process.env.REACT_APP_BASE_URL + "/api/listOfUser";
            let body = {
            }
            console.log("************handleUserData************ ")
            await axios.post(url, body, {
                headers: {
                    'authorization': `${userDetails.access_token}`
                },
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {
                        setUserData(response.data.list)
                        // console.log("************handle-UserData************ ", response.data.list)

                        setError(undefined)

                    }
                    else if (response.data.statusCode === 1) {
                        setError(undefined);
                    }


                    else {

                        setError(response.data.msg)
                        setTimeout(() => errortimer(), 2000)
                        console.log(" companyWiseDeviceList error: ", response.data.msg);
                    }

                    // setLoading (false);
                }

                else if (response.status == 403) {
                    navigate("/");
                }
            }).catch(error => {
                console.log("error: ", error);
                if (error.response.status == 403) {
                    navigate("/");
                }

                setError("Slow or no internet connected. Please check your internet connection.")
                setTimeout(() => handleUserData(), 500)
                return
            })
        } catch (error) {
            console.log("error1 ", error)
            setError("Slow or no internet connected. Please check your internet")
            setTimeout(() => handleUserData(), 500)
            return
            // throw error;
        }

        // setLoading(false);
    }

    const ValidateRole = (role) => {
        if (role == "A")
            return "Admin"

        else if (role == "M")
            return "Machine Incharge"

        else if (role == "F")
            return "Floor Manager"


        else if (role == "O")
            return "Owner"

        else
            return "Controller"



    }

    React.useEffect(() => {
        handleUserData();
    }, []);

    return (
        <div className='main'>

            <div>
                <ControllerNavbar />
            </div>

            <div className='Admin_menu' style={{ marginTop: "20px" }}>
                <Header show={3} sendNavbarToParent={navbarRender} />

                <DataTable
                    columns={userColumns}
                    data={userData}
                />
            </div>
        </div >

    )
}

export default ControllerUser
